import _ from 'lodash';
import {
  FETCH_DRIVERS,
  FETCH_DRIVER,
  DELETE_DRIVER
} from '../actions/types';

const INITIAL_STATE: Object = {};

export default (state: Object = INITIAL_STATE, action: Object): Object => {
  switch (action.type) {
    case FETCH_DRIVERS:
      return { ..._.mapKeys(action.payload, 'driverId') };
    case FETCH_DRIVER:
      return { ...state, [action.payload.driverId]: action.payload };
    case DELETE_DRIVER:
      return { ..._.omit(state, action.payload)};
    default:
      return state;
  }
};